// extracted by mini-css-extract-plugin
export default {"shimmerWrapper":"SidePannelShimmer_shimmerWrapper__Neyjr","shimmer":"SidePannelShimmer_shimmer__44jDy"};